import { Breadcrumbs, Typography } from "@mui/material";
import usePage from "hooks/usePage";
import useFetch from "hooks/useFetch";

export default function ViewerProjectBreadcrumb() {
  const { projectId } = usePage();

  const { data: project } = useFetch(
    `/hash/project/${projectId}`,
    {},
    !!projectId
  );

  return (
    <Breadcrumbs sx={{ display: "flex", alignItems: "center", p: 2 }}>
      <Typography variant="h5">{project?.name}</Typography>
    </Breadcrumbs>
  );
}
